import {Icon} from 'semantic-ui-react';
import styled from 'styled-components';

const Center=styled.div`
    display:flex;
    justify-content:center;
`;
export default ()=>(
    <Center>
        <Icon size="large" name='circle notched' loading />
    </Center>
);